import React from "react"

export default React.createContext({ socket: null, setSocket: null })
